import React from 'react';

/**
 * "Force open · YYYY-MM-DD" modal — used when the barber clicks on a
 * normally-off weekday and wants to open it for the day.
 */
export const ForceOpenModal = ({ openEditor, setOpenEditor, onSave }) => (
  <div className="sched-modal-back" onClick={() => setOpenEditor(null)}>
    <div className="sched-modal" onClick={(e) => e.stopPropagation()} data-testid="sched-force-open-modal">
      <h3>Force open · {openEditor.date}</h3>
      <p className="mute">This day is normally your day off. Set the hours you&apos;ll work.</p>
      <div className="fo-grid">
        <div className="field">
          <label>Start</label>
          <input
            type="time"
            className="inp"
            value={openEditor.start}
            onChange={(e) => setOpenEditor({ ...openEditor, start: e.target.value })}
            data-testid="sched-force-start"
          />
        </div>
        <div className="field">
          <label>End</label>
          <input
            type="time"
            className="inp"
            value={openEditor.end}
            onChange={(e) => setOpenEditor({ ...openEditor, end: e.target.value })}
            data-testid="sched-force-end"
          />
        </div>
      </div>
      <div className="modal-actions">
        <button className="btn s" onClick={() => setOpenEditor(null)}>Cancel</button>
        <button className="btn p" onClick={onSave} data-testid="sched-force-save">Add</button>
      </div>
    </div>
  </div>
);
